export const FULL_CONTENT_BOUNDS = { x: 0, y: 0, width: 1, height: 1 };

const SAMPLE_MAX_SIDE = 280;
const ALPHA_THRESHOLD = 20;
const WHITE_THRESHOLD = 10;
const MIN_COVERAGE = 0.04;
const cache = new Map();

export function detectImageContentBounds(image, cacheKey) {
  const key = cacheKey || image.currentSrc || image.src;
  if (key && cache.has(key)) return cache.get(key);

  const naturalWidth = image.naturalWidth;
  const naturalHeight = image.naturalHeight;
  if (!naturalWidth || !naturalHeight) return FULL_CONTENT_BOUNDS;

  try {
    const scale = Math.min(1, SAMPLE_MAX_SIDE / Math.max(naturalWidth, naturalHeight));
    const width = Math.max(1, Math.round(naturalWidth * scale));
    const height = Math.max(1, Math.round(naturalHeight * scale));
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) return FULL_CONTENT_BOUNDS;
    ctx.drawImage(image, 0, 0, width, height);
    const { data } = ctx.getImageData(0, 0, width, height);

    let minX = width;
    let minY = height;
    let maxX = -1;
    let maxY = -1;

    for (let y = 0; y < height; y += 1) {
      for (let x = 0; x < width; x += 1) {
        const index = (y * width + x) * 4;
        if (data[index + 3] <= ALPHA_THRESHOLD) continue;
        const darkest = Math.min(data[index], data[index + 1], data[index + 2]);
        if (darkest >= WHITE_THRESHOLD) continue;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      }
    }

    if (maxX < minX || maxY < minY) return FULL_CONTENT_BOUNDS;
    const bounds = {
      x: minX / width,
      y: minY / height,
      width: (maxX - minX + 1) / width,
      height: (maxY - minY + 1) / height,
    };
    if (bounds.width * bounds.height < MIN_COVERAGE) return FULL_CONTENT_BOUNDS;
    if (key) cache.set(key, bounds);
    return bounds;
  } catch {
    return FULL_CONTENT_BOUNDS;
  }
}
